import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { find } from 'lodash';
import Markdown from 'react-markdown-el';
import ReactGA from 'react-ga';

import arrowLeft from './arrowLeft.svg';
import mailButton from './mailButton.svg';


class Email extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: '',
    };
  }

  componentWillMount() {

    if (this.props.reps.length === 0) {
      browserHistory.push(`/${this.props.params.appId}`);
      return;
    }

    if (this.props.reps) {
      let rep = find(this.props.reps, (rep) => rep.bioguide_id === this.props.params.id);
      this.setState({
        email: rep.oc_email,
        text: eval('`'+this.props.messages.email+'`'),
      });
    }
  }

  handleChange = (text) => {
    this.setState({ text });
  }

  handleClick = () => {
    ReactGA.event({
      category: 'Bespoke Contact Congress',
      action: 'click',
      label: 'send email'
    });
  }

  handleBack = () => {
    ReactGA.event({
      category: 'Bespoke Contact Congress',
      action: 'click',
      label: 'previous'
    });

    browserHistory.goBack();
  }

  render() {
    return (
      <div className="Email">
        <h2>Email your Legislator</h2>
          <label className="zipLabel" htmlFor="zip">EDIT AS DESIRED:</label>
          <div className="wrapInput">
            <textarea
              onChange={(e) => this.handleChange(e.target.value)}
              value={this.state.text}
            ></textarea>
          </div>
          <a className="emailButton" target="_parent" onClick={this.handleClick} href={`mailto:${this.state.email}?body=${encodeURIComponent(this.state.text)}`}><img src={mailButton} /></a>
          <a className="previousButton" onClick={this.handleBack}><img className="previousArrow" src={arrowLeft} />Previous</a>
      </div>
    );
  }
};

export default Email;




// WEBPACK FOOTER //
// ./src/Email.js